export default () => {
    const mainHeaderSearchContainer = document.querySelector(
        ".main-header__search"
    );
    const mainHeaderSearchIcon = mainHeaderSearchContainer.querySelector(
        ".main-header__search__icon"
    );
    const mainHeaderSearchForm = mainHeaderSearchContainer.querySelector(
        ".main-header__search-form"
    );

    mainHeaderSearchIcon.addEventListener("click", () => {
        mainHeaderSearchIcon.classList.toggle("is-active");
        mainHeaderSearchForm.classList.toggle("is-active");
    });
};
